module.exports = __webpack_public_path__ + "img/lock-icon.25229d87.svg";